import i18n from 'shared/lib/i18n';

import {
  ADD_RSVP_GUEST_FAILURE,
  ADD_RSVP_GUEST_REQUEST,
  ADD_RSVP_GUEST_SUCCESS,
  CLEAR_EVENTS_STATE,
  CREATE_EVENT_FAILURE,
  CREATE_EVENT_REQUEST,
  CREATE_EVENT_SUCCESS,
  CREATE_RSVP_FAILURE,
  CREATE_RSVP_REQUEST,
  CREATE_RSVP_SUCCESS,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_RSVP_FAILURE,
  DELETE_EVENT_RSVP_GUEST_FAILURE,
  DELETE_EVENT_RSVP_GUEST_REQUEST,
  DELETE_EVENT_RSVP_GUEST_SUCCESS,
  DELETE_EVENT_RSVP_REQUEST,
  DELETE_EVENT_RSVP_SUCCESS,
  DELETE_EVENT_SUCCESS,
  GET_EVENTS_LIST_FAILURE,
  GET_EVENTS_LIST_REQUEST,
  GET_EVENTS_LIST_SUCCESS,
  GET_EVENT_DATA_FAILURE,
  GET_EVENT_DATA_REQUEST,
  GET_EVENT_DATA_SUCCESS,
  GET_EVENT_RSVPS_FAILURE,
  GET_EVENT_RSVPS_FOR_FILTER_FAILURE,
  GET_EVENT_RSVPS_FOR_FILTER_REQUEST,
  GET_EVENT_RSVPS_FOR_FILTER_SUCCESS,
  GET_EVENT_RSVPS_REQUEST,
  GET_EVENT_RSVPS_SUCCESS,
  SET_MODAL_TYPE,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
} from '../../../actionConstants';
import { uploadImage } from '../../Visitor/actionCreators';

import { isFile } from '../utils';

import apiClient from '../../../apiClient';
import { CONFIRM } from '../../Modal/modalTypes';

export const getEvents = (dispatch, queryParams) =>
  dispatch({
    type: GET_EVENTS_LIST_REQUEST,
    payload: apiClient.events.getEventsList(queryParams).then(
      (res) =>
        dispatch({
          type: GET_EVENTS_LIST_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_EVENTS_LIST_FAILURE,
          err,
        }),
    ),
  });

export const getEventData = (dispatch, id) =>
  dispatch({
    type: GET_EVENT_DATA_REQUEST,
    payload: apiClient.events.getEventData(id).then(
      (res) =>
        dispatch({
          type: GET_EVENT_DATA_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_EVENT_DATA_FAILURE,
          err,
        }),
    ),
  });

export const createEvent = (dispatch, data, image) =>
  dispatch({
    type: CREATE_EVENT_REQUEST,
    payload: apiClient.events.createEvent(data).then(
      async (res) => {
        dispatch({
          type: CREATE_EVENT_SUCCESS,
          res,
        });

        const { id } = res?.data || {};
        if (image?.length && id) {
          const url = `social-events/${id}/photo/`;
          await uploadImage(dispatch, image, url);
        }
        return res;
      },
      (err) =>
        dispatch({
          type: CREATE_EVENT_FAILURE,
          err,
        }),
    ),
  });
export const updateEvent = (dispatch, id, data, image) =>
  dispatch({
    type: UPDATE_EVENT_REQUEST,
    payload: apiClient.events.updateEvent(id, data).then(
      async (res) => {
        dispatch({
          type: UPDATE_EVENT_SUCCESS,
          res,
        });

        if (image?.length && id && isFile(image[0])) {
          const url = `social-events/${id}/photo/`;
          await uploadImage(dispatch, image, url);
        }
        return res;
      },
      (err) =>
        dispatch({
          type: UPDATE_EVENT_FAILURE,
          err,
        }),
    ),
  });

export const deleteEvent = (dispatch, id, queryParams) =>
  dispatch({
    type: DELETE_EVENT_REQUEST,
    payload: apiClient.events.deleteEvent(id).then(
      (res) => {
        dispatch({
          type: DELETE_EVENT_SUCCESS,
          res,
          id,
        });

        return getEvents(dispatch, queryParams);
      },
      (err) =>
        dispatch({
          type: DELETE_EVENT_FAILURE,
          err,
        }),
    ),
  });

export const clearEventData = (dispatch) =>
  dispatch({ type: CLEAR_EVENTS_STATE });

export const getEventRsvps = (dispatch, queryParams) =>
  dispatch({
    type: GET_EVENT_RSVPS_REQUEST,
    payload: apiClient.events.getEventRsvps(queryParams).then(
      (res) =>
        dispatch({
          type: GET_EVENT_RSVPS_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_EVENT_RSVPS_FAILURE,
          err,
        }),
    ),
  });

export const deleteRsvpGuestFromEvent = (
  dispatch,
  rsvpId,
  guestId,
  queryParams,
) =>
  dispatch({
    type: DELETE_EVENT_RSVP_GUEST_REQUEST,
    payload: apiClient.events.deleteRsvpGuestFromEvent(rsvpId, guestId).then(
      (res) => {
        dispatch({
          type: DELETE_EVENT_RSVP_GUEST_SUCCESS,
          res,
        });

        return getEventRsvps(dispatch, queryParams);
      },
      (err) =>
        dispatch({
          type: DELETE_EVENT_RSVP_GUEST_FAILURE,
          err,
        }),
    ),
  });

export const deleteRsvpFromEvent = (dispatch, rsvpId, queryParams) =>
  dispatch({
    type: DELETE_EVENT_RSVP_REQUEST,
    payload: apiClient.events.deleteRsvpFromEvent(rsvpId).then(
      (res) => {
        dispatch({
          type: DELETE_EVENT_RSVP_SUCCESS,
          res,
        });

        return getEventRsvps(dispatch, queryParams);
      },
      (err) =>
        dispatch({
          type: DELETE_EVENT_RSVP_FAILURE,
          err,
        }),
    ),
  });

export const confirmDeleteRsvp = (dispatch, rsvpId, queryParams) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: () => deleteRsvpFromEvent(dispatch, rsvpId, queryParams),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const confirmDeleteGuest = (dispatch, rsvpId, guestId, queryParams) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: () =>
      deleteRsvpGuestFromEvent(dispatch, rsvpId, guestId, queryParams),
  };
  return dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const getEventRsvpsForFilter = (dispatch, queryParams) =>
  dispatch({
    type: GET_EVENT_RSVPS_FOR_FILTER_REQUEST,
    payload: apiClient.events.getEventRsvps(queryParams).then(
      (res) =>
        dispatch({
          type: GET_EVENT_RSVPS_FOR_FILTER_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_EVENT_RSVPS_FOR_FILTER_FAILURE,
          err,
        }),
    ),
  });

export const createRsvp = (dispatch, data, queryParams) =>
  dispatch({
    type: CREATE_RSVP_REQUEST,
    payload: apiClient.events.createRsvp(data).then(
      (res) => {
        dispatch({
          type: CREATE_RSVP_SUCCESS,
          res,
        });
        getEventRsvps(dispatch, queryParams);
        return res;
      },
      (err) =>
        dispatch({
          type: CREATE_RSVP_FAILURE,
          err,
        }),
    ),
  });

export const addRsvpGuest = (dispatch, rsvpId, data, queryParams) =>
  dispatch({
    type: ADD_RSVP_GUEST_REQUEST,
    payload: apiClient.events.addRsvpGuest(rsvpId, data).then(
      (res) => {
        dispatch({
          type: ADD_RSVP_GUEST_SUCCESS,
          res,
        });
        getEventRsvps(dispatch, queryParams);
        return res;
      },
      (err) =>
        dispatch({
          type: ADD_RSVP_GUEST_FAILURE,
          err,
        }),
    ),
  });
